// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header */
.tasksPages_header__dlX4V {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  justify-content: space-between;
  background: var(--header);
  color: var(--header);
  height: 6vh;
  align-items: center;
}

.tasksPages_headerTitleContainer__VwdaA {
  display: flex;
  flex-direction: row;
  padding-right: 10px;
}

.tasksPages_headerTitle__l72jZ {
  text-transform: uppercase;
  color: #fff;
  padding-left: 1rem;
}

.tasksPages_filterBtnContainer__J9Yuc {
  display: flex;
  align-items: flex-start;
}

.tasksPages_searchContainer__KyMJ- {
  padding-right: 1rem;
}

.tasksPages_tableContainer__c5qnK {
  padding: 0.5rem 4rem 0 4rem;
}

/* table header */
.tasksPages_title__cH8\\+T {
  padding-right: 0.5rem;
  font-size: 1rem;
  font-weight: 800;
}

.tasksPages_orderNum__kh-vk {
  font-size: 1rem;
  cursor: pointer;
  padding-right: 4.5rem;
  color: var(--header);
  font-weight: 800;
  text-decoration: none;
}

/* redundant but needed for override */
.tasksPages_orderNum__kh-vk:hover {
  font-size: 1rem;
  cursor: pointer;
  padding-right: 4.5rem;
  color: var(--header);
  font-weight: 800;
  text-decoration: underline;
}

.tasksPages_headerCell__rOEiA {
  border-bottom: 2px solid black !important;
  padding: 0 !important;
  line-height: 0;
}

.tasksPages_brBtm__dIEQJ {
  border-bottom: 2px solid black !important;
}

.tasksPages_headerTxt__CGOWm {
  padding-right: 0.2rem;
  line-height: 0;
}

.tasksPages_headerCompleted__FLF6Y {
  font-weight: bold;
  font-size: 1rem;
}

.tasksPages_headerNumContainer__EkS1B {
  font-size: 1.1rem;
}

.tasksPages_completedTasks__H-QPq {
  font-weight: 800;
}

/* table rows */
.tasksPages_modelCell__seW-U {
  padding: 0 !important;
  max-width: 7em;
  border-bottom: 0;
}

.tasksPages_modelContainer__XSNS4 {
  display: flex;
  flex-direction: column;
  line-height: 1;
  justify-content: center;
}

.tasksPages_modelId__37Lt0 {
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--black75);
}

.tasksPages_modelName__xSslC {
  font-size: 0.7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 10rem;
}

.tasksPages_flexRow__LYnK5 {
  display: flex;
  flex-direction: row;
}

.tasksPages_flexC__rm7cj {
  display: flex;
  flex-direction: column;
}

.tasksPages_pd0__y5zU2 {
  padding: 0 !important;
}

.tasksPages_noBrdBottom__ovDPI {
  border-bottom: 0;
}

.tasksPages_quantityNum__xs2kF {
  font-size: 0.95rem;
  font-weight: bold;
  color: var(--black75);
}

.tasksPages_smallText__Pel4P {
  font-size: 0.6rem;
}

.tasksPages_capitalizeText__HdVRY {
  text-transform: capitalize;
}

.tasksPages_lowerText__l-wBw {
  text-transform: lowercase;
}

.tasksPages_matContainer__AJzvj {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

.tasksPages_dimContainer__jfq1B {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
}

.tasksPages_matText__dsRZt {
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--black75);
  text-transform: uppercase;
}

.tasksPages_titleText__y7NdX {
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--black75);
}

.tasksPages_iconsContainer__DeJ61 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tasksPages_iconContainer__-1Z3q {
  padding-right: 0.5rem;
}

.tasksPages_stepIcon__ynfsY {
  fill: var(--black75) !important;
  cursor: pointer;
}

.tasksPages_pdfIcon__1dV7A {
  fill: var(--mainYellow);
  cursor: pointer;
}

.tasksPages_notActiveIcon__CmdUx {
  fill: var(--black10) !important;
}

.tasksPages_activeIcon__1tTrh {
  fill: var(--mainYellow);
}

.tasksPages_threadTooltipBkgr__pwBVB {
  background: var(--white);
}

.tasksPages_personIcon__fJAFq {
  cursor: pointer;
}

.tasksPages_chatPopup__GJzIz {
  position: absolute;
}

.tasksPages_finishTitle__hKEFV {
  text-transform: capitalize;
  font-size: 0.8rem;
  font-weight: bold;
  color: var(--black75);
}

.tasksPages_assignContainer__gFXGr {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tasks_management/css/tasksPages.module.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":["/* header */\n.header {\n  display: flex;\n  flex-direction: row;\n  padding-top: 20px;\n  justify-content: space-between;\n  background: var(--header);\n  color: var(--header);\n  height: 6vh;\n  align-items: center;\n}\n\n.headerTitleContainer {\n  display: flex;\n  flex-direction: row;\n  padding-right: 10px;\n}\n\n.headerTitle {\n  text-transform: uppercase;\n  color: #fff;\n  padding-left: 1rem;\n}\n\n.filterBtnContainer {\n  display: flex;\n  align-items: flex-start;\n}\n\n.searchContainer {\n  padding-right: 1rem;\n}\n\n.tableContainer {\n  padding: 0.5rem 4rem 0 4rem;\n}\n\n/* table header */\n.title {\n  padding-right: 0.5rem;\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.orderNum {\n  font-size: 1rem;\n  cursor: pointer;\n  padding-right: 4.5rem;\n  color: var(--header);\n  font-weight: 800;\n  text-decoration: none;\n}\n\n/* redundant but needed for override */\n.orderNum:hover {\n  font-size: 1rem;\n  cursor: pointer;\n  padding-right: 4.5rem;\n  color: var(--header);\n  font-weight: 800;\n  text-decoration: underline;\n}\n\n.headerCell {\n  border-bottom: 2px solid black !important;\n  padding: 0 !important;\n  line-height: 0;\n}\n\n.brBtm {\n  border-bottom: 2px solid black !important;\n}\n\n.headerTxt {\n  padding-right: 0.2rem;\n  line-height: 0;\n}\n\n.headerCompleted {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.headerNumContainer {\n  font-size: 1.1rem;\n}\n\n.completedTasks {\n  font-weight: 800;\n}\n\n/* table rows */\n.modelCell {\n  padding: 0 !important;\n  max-width: 7em;\n  border-bottom: 0;\n}\n\n.modelContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: 1;\n  justify-content: center;\n}\n\n.modelId {\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: var(--black75);\n}\n\n.modelName {\n  font-size: 0.7rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 10rem;\n}\n\n.flexRow {\n  display: flex;\n  flex-direction: row;\n}\n\n.flexC {\n  display: flex;\n  flex-direction: column;\n}\n\n.pd0 {\n  padding: 0 !important;\n}\n\n.noBrdBottom {\n  border-bottom: 0;\n}\n\n.quantityNum {\n  font-size: 0.95rem;\n  font-weight: bold;\n  color: var(--black75);\n}\n\n.smallText {\n  font-size: 0.6rem;\n}\n\n.capitalizeText {\n  text-transform: capitalize;\n}\n\n.lowerText {\n  text-transform: lowercase;\n}\n\n.matContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  line-height: 1;\n}\n\n.dimContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1;\n}\n\n.matText {\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: var(--black75);\n  text-transform: uppercase;\n}\n\n.titleText {\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: var(--black75);\n}\n\n.iconsContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.iconContainer {\n  padding-right: 0.5rem;\n}\n\n.stepIcon {\n  fill: var(--black75) !important;\n  cursor: pointer;\n}\n\n.pdfIcon {\n  fill: var(--mainYellow);\n  cursor: pointer;\n}\n\n.notActiveIcon {\n  fill: var(--black10) !important;\n}\n\n.activeIcon {\n  fill: var(--mainYellow);\n}\n\n.threadTooltipBkgr {\n  background: var(--white);\n}\n\n.personIcon {\n  cursor: pointer;\n}\n\n.chatPopup {\n  position: absolute;\n}\n\n.finishTitle {\n  text-transform: capitalize;\n  font-size: 0.8rem;\n  font-weight: bold;\n  color: var(--black75);\n}\n\n.assignContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `tasksPages_header__dlX4V`,
	"headerTitleContainer": `tasksPages_headerTitleContainer__VwdaA`,
	"headerTitle": `tasksPages_headerTitle__l72jZ`,
	"filterBtnContainer": `tasksPages_filterBtnContainer__J9Yuc`,
	"searchContainer": `tasksPages_searchContainer__KyMJ-`,
	"tableContainer": `tasksPages_tableContainer__c5qnK`,
	"title": `tasksPages_title__cH8+T`,
	"orderNum": `tasksPages_orderNum__kh-vk`,
	"headerCell": `tasksPages_headerCell__rOEiA`,
	"brBtm": `tasksPages_brBtm__dIEQJ`,
	"headerTxt": `tasksPages_headerTxt__CGOWm`,
	"headerCompleted": `tasksPages_headerCompleted__FLF6Y`,
	"headerNumContainer": `tasksPages_headerNumContainer__EkS1B`,
	"completedTasks": `tasksPages_completedTasks__H-QPq`,
	"modelCell": `tasksPages_modelCell__seW-U`,
	"modelContainer": `tasksPages_modelContainer__XSNS4`,
	"modelId": `tasksPages_modelId__37Lt0`,
	"modelName": `tasksPages_modelName__xSslC`,
	"flexRow": `tasksPages_flexRow__LYnK5`,
	"flexC": `tasksPages_flexC__rm7cj`,
	"pd0": `tasksPages_pd0__y5zU2`,
	"noBrdBottom": `tasksPages_noBrdBottom__ovDPI`,
	"quantityNum": `tasksPages_quantityNum__xs2kF`,
	"smallText": `tasksPages_smallText__Pel4P`,
	"capitalizeText": `tasksPages_capitalizeText__HdVRY`,
	"lowerText": `tasksPages_lowerText__l-wBw`,
	"matContainer": `tasksPages_matContainer__AJzvj`,
	"dimContainer": `tasksPages_dimContainer__jfq1B`,
	"matText": `tasksPages_matText__dsRZt`,
	"titleText": `tasksPages_titleText__y7NdX`,
	"iconsContainer": `tasksPages_iconsContainer__DeJ61`,
	"iconContainer": `tasksPages_iconContainer__-1Z3q`,
	"stepIcon": `tasksPages_stepIcon__ynfsY`,
	"pdfIcon": `tasksPages_pdfIcon__1dV7A`,
	"notActiveIcon": `tasksPages_notActiveIcon__CmdUx`,
	"activeIcon": `tasksPages_activeIcon__1tTrh`,
	"threadTooltipBkgr": `tasksPages_threadTooltipBkgr__pwBVB`,
	"personIcon": `tasksPages_personIcon__fJAFq`,
	"chatPopup": `tasksPages_chatPopup__GJzIz`,
	"finishTitle": `tasksPages_finishTitle__hKEFV`,
	"assignContainer": `tasksPages_assignContainer__gFXGr`
};
export default ___CSS_LOADER_EXPORT___;
